import { useNavigate } from 'react-router-dom';
import TopNavigation from '@cloudscape-design/components/top-navigation';

interface BeaconHeaderProps {
  selectedRegion: string;
  onRegionChange: (regionId: string) => void;
  userName?: string;
}

const regionLabel = (id: string): string => {
  const map: Record<string, string> = {
    'us-east-1': 'IAD (us-east-1)',
    'us-west-2': 'PDX (us-west-2)',
    'eu-west-1': 'DUB (eu-west-1)',
  };
  return map[id] || id;
};

export const BeaconHeader = ({
  selectedRegion,
  onRegionChange,
  userName = 'anantgoy', // TODO: change it fetch using redux
}: BeaconHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div id="beacon-header">
      <style>{`
        #beacon-header [class*="top-navigation"] {
          background-color: #232f3e !important;
        }
        #beacon-header [class*="top-navigation"] [class*="identity"] span[class*="title"] {
          color: #ffffff !important;
        }
        #beacon-header [class*="top-navigation"] [class*="identity"] span[class*="title"]::after {
          content: ' Beacon';
          color: #fa9e14;
        }
      `}</style>
      <TopNavigation
        identity={{
          href: '/',
          title: 'Fintech |',
          onFollow: (e) => {
            e.preventDefault();
            navigate('/');
          },
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            text: regionLabel(selectedRegion),
            iconName: 'multiscreen',
            ariaLabel: 'Region selector',
            items: [
              { id: 'us-east-1', text: 'IAD (us-east-1)' },
              { id: 'us-west-2', text: 'PDX (us-west-2)' },
              { id: 'eu-west-1', text: 'DUB (eu-west-1)' },
            ],
            onItemClick: ({ detail }: { detail: { id: string } }) => onRegionChange(detail.id),
          },
          {
            type: 'button',
            text: userName,
            iconUrl: `https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${userName}`,
            iconAlt: `${userName} photo`,
            ariaLabel: 'User',
          },
        ]}
      />
    </div>
  );
};
